import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import GoogleMapReact from 'google-map-react'
import settings from "settings"
import _ from 'lodash'
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"

class HeatClosings extends Component {
	constructor(props) {
		super(props)

		this.state = {
			heat: [],
			sorted: [],
			columns: [
				{
					Header: "Zip",
					accessor: "zip",
					//Cell: ({ row }) => <Link to={{ pathname: `/zipcode/${row.zip}` }}>{row.zip}</Link>,
				},
				{
					Header: "City",
					accessor: "city",
					filterMethod: (f, r) => helpers.tableText(f, r, "city"),
				},
				{
					Header: "State",
					accessor: "state",
					filterMethod: (f, r) => helpers.tableText(f, r, "state"),
				},
				{
					Header: "Total Sales",
					accessor: "total",
					sort: "asc",
				},
			],
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.payload.sales.current.length !== this.props.payload.sales.current.length) {
			this.buildData()
		}
	}

	componentDidMount() {
		this.buildData()
	}

	buildTable = () => {
		var data = []
		var zips = {}
		_.forEach(this.props.payload.closings.current, (r) => {
			if (!r.buyer_zip) {
				return
			}
			var zip = r.buyer_zip.toString()
			if (!_.has(zips, zip)) {
				_.setWith(zips, zip, { total: 0, city: r.buyer_city, state: r.buyer_state }, Object)
			}
			zips[zip].total++
		})
		_.forEach(zips, (r, k) => {
			data.push({ zip: k, total: r.total, city: r.city, state: r.state })
		})
		return data
	}

	buildData = () => {
		var points = {
			positions: [],
			options: {
				radius: settings.heatMapRadius,
			},
		}
		this.props.payload.closings.current.forEach(r => {
			if (!r.lat || !r.lng) {
				return
			}
			points.positions.push({ lat: r.lat, lng: r.lng })
		})
		this.setState({ heat: points })
	}

	mapCenter = () => {
		if (this.props.activeProperties.length > 0) {
			let prop = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
			if (prop) {
				return {
					lat: prop.lat,
					lng: prop.lng,
				}
			}
		} else {
			return settings.mapCenter
		}
	}

	render() {

		if (this.props.payloadStatus) {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Closings Heat Map" />
						<div className="heatmap">
							<GoogleMapReact
								bootstrapURLKeys={{
									key: settings.gmapsApiKey,
									libraries: "visualization",
								}}
								defaultCenter={this.mapCenter()}
								defaultZoom={10}
								heatmapLibrary={true}
								heatmap={this.state.heat}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h2>Zip Code Table</h2>
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns}
								name="heatClosings__zips"
								title="Zips"
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(HeatClosings)
